import { INotification } from "shared/components/organisms/AppNotification/@types";
import { ICampaignMetaData } from "shared/components/organisms/AppNotification/@types/campaignTypes";
import { NotificationBell } from "shared/components/organisms/AppNotification/assets/icons/NotificationBell";
import { NotificationBellRead } from "shared/components/organisms/AppNotification/assets/icons/NotificationBellRead";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { CampaignNotificationContainer } from "./styles";

interface ICampaignNotificationProps {
  notification: INotification<ICampaignMetaData>;
}

export const CampaignNotification = ({
  notification,
}: ICampaignNotificationProps) => {
  return (
    <CampaignNotificationContainer>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          {!!notification?.read_at ? (
            <NotificationBellRead />
          ) : (
            <NotificationBell />
          )}
        </Notification.IllustrationContainer>
        <Notification.Title.Container>
          <Notification.Title.Highlight>
            {notification?.metadata?.subject}
          </Notification.Title.Highlight>

          <Notification.Content.Text>
            {notification?.metadata?.content}
          </Notification.Content.Text>
        </Notification.Title.Container>
        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>
        </Notification.Footer.Container>
      </Notification.Container>
    </CampaignNotificationContainer>
  );
};
